"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPage = void 0;
const user_hooks_1 = require("@hooks/user.hooks");
const expandable_grid_1 = __importDefault(require("@shared-modules/components/expandable-grid"));
const React = __importStar(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const AdminPage = (props) => {
    const { list: records, forceReload, setPage, loaderState: { total = 0, size }, } = (0, user_hooks_1.useCreatorList)();
    const approveRequest = (0, helper_1.useApproveRequest)();
    const { data: { isAdmin = false } = {} } = (0, user_hooks_1.useCurrentUser)();
    const approveRequestHandler = (account) => __awaiter(void 0, void 0, void 0, function* () {
        yield approveRequest(account);
        forceReload();
    });
    const rejectUser = (0, user_hooks_1.useCreatorReject)();
    const rejectRequestHandler = (account) => __awaiter(void 0, void 0, void 0, function* () {
        yield rejectUser(account);
        forceReload();
    });
    if (!isAdmin) {
        return null;
    }
    return (React.createElement("div", { className: "p-admin" },
        React.createElement(expandable_grid_1.default, { columns: (0, helper_1.getGridColumns)(approveRequestHandler, rejectRequestHandler), data: records, getDataId: ({ wallet }) => wallet, onPageChange: setPage, totalRows: total, pageSize: size })));
};
exports.AdminPage = AdminPage;
exports.default = exports.AdminPage;
